import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeWorkingCalendar  {
    _originalTypeClassName = "zERP.BO.EmployeeWorkingCalendar";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeWorkingCalendar.translate = translateService;
}
this.Payroll = new Domain.EmployeePayroll();
this.Days = [];
this.PeriodFrom = null;
this.PeriodTo = null;
this.EmployeeWorkingCalendarKey = null;
this._key = this.EmployeeWorkingCalendarKey = 0; 
}

static translate: TranslateService;
_key: any;
PeriodFrom:any;
PeriodTo:any;
Payroll:any;
Employee:any;
TaskLogSection:any;
Days:any;
private _EmployeeWorkingCalendarKey:any;
get EmployeeWorkingCalendarKey(): any {
    return this._EmployeeWorkingCalendarKey;
  }
set EmployeeWorkingCalendarKey(value: any) {
    this._EmployeeWorkingCalendarKey = value;
    this._key = value;
  }
static setPayroll = ($this, value) => {
var oldValue = $this.Payroll;
$this.Payroll = value;
if (value != null) {
if (oldValue != null && oldValue.Calendar != null) { oldValue.Calendar = null; }
if ($this.Payroll.Calendar !== $this) {
Domain.EmployeePayroll.setCalendar(value, $this);
}
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setTaskLogSection = ($this, value) => {
var oldValue = $this.TaskLogSection;
$this.TaskLogSection = value;
if (value != null) {
}
}
static setDays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Days == null) $this.Days = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Days.length > 0) {
                    Domain.EmployeeWorkingCalendar.removeDays($this, $this.Days[0]);
                }

                Domain.EmployeeWorkingCalendar.addManyDays($this, copyItems);
            }
static addManyDays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeWorkingCalendar.addDays($this, items[i]);
                }
            }
static addDays = ($this, item) => {
                if ($this.Days == null) $this.Days = [];
                if (item == null || $this.Days.indexOf(item) > -1) return;
                $this.Days.push(item);
if (item.EmployeeWorkingCalendar != $this) {
Domain.EmployeeWorkingCalendarDay.setEmployeeWorkingCalendar(item, $this);
}
}
static addRangeDays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeWorkingCalendar.addDays($this, item));
            }
static removeDays = ($this, item) => {
                if ($this == null || $this.Days == null || $this.Days.indexOf(item) === -1) return;
                var _index = $this.Days.indexOf(item);
                $this.Days.splice(_index, 1);
item.EmployeeWorkingCalendar = null;
}
static clearDays = ($this) => { $this.Days = null; }

static IsInsuredDate($this: any, date: any): any{return Domain.ContractDaysConfiguration.IsUnsured($this?.Employee?.Template?.ContractType?.DaysConfiguration, date);
}
static IsWorkingDate($this: any, leave: any,date: any,holidaysAsWorkingDays: any): any{if (leave != null && (leave?.BalanceCallendar == Domain.LeaveBalanceCalendar.Calendar || leave?.BalanceCallendar == Domain.LeaveBalanceCalendar.None)) {return true;}
if (holidaysAsWorkingDays == false && Domain.BusinessEntity.IsHoliday($this?.Employee?.Entity, date)) {return false;}
return CLMS.Framework.Number.GreaterThan(() => Domain.ContractDaysConfiguration.WorkingHours($this.Employee.Template.ContractType.DaysConfiguration, date), () => 0);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeWorkingCalendarKey == null || $this.EmployeeWorkingCalendarKey == 0;
            }


}